import { render } from "./InputRequiredNumber.vue?vue&type=template&id=60094b72&scoped=true"
import script from "./InputRequiredNumber.vue?vue&type=script&lang=js"
export * from "./InputRequiredNumber.vue?vue&type=script&lang=js"

import "./InputRequiredNumber.vue?vue&type=style&index=0&id=60094b72&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3368735133/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60094b72"]])

export default __exports__